/* eslint-disable no-shadow */
import * as PropTypes from "prop-types"
import React from "react"
import ReactMarkdown from "react-markdown"
import { useSelector, useDispatch } from "react-redux"

import Cta from "./Cta"
import { dismissModal } from "../slices/modalSlice" // ✅ RTK slice action
import { VISIBLE, BUTTON } from "../helpers/constants"

const Modal = ({ restartTimeout }) => {
  const dispatch = useDispatch()

  const { isModalVisible, modalData } = useSelector(state => state.modal) // ✅ RTK slice state

  const translations = useSelector(state => state.data.translations)

  const { ctaType, content, title, image, ctaText, ctaUrl, action, ctaSize, modalModifier } = modalData || {}

  const _visible = isModalVisible ? VISIBLE : ""

  const timeoutRestartAction = () => {
    if (restartTimeout) restartTimeout()
    dispatch(dismissModal())
  }

  const modalAction = action ? timeoutRestartAction : () => dispatch(dismissModal())

  const cta = {
    text: ctaText || translations.application?.labels?.close,
    mixModifier: "cta--rounded",
    type: ctaType || BUTTON,
    size: ctaSize,
    action: modalAction,
    url: ctaUrl || null,
    className: "modal__close-button"
  }

  return (
    <div className={`modal modal--${_visible}`}>
      <div className={`modal__inner modal__inner--${modalModifier || ""}`}>
        <div className="modal__column">
          {title && (
            <div className="modal__header">
              <h3 className="modal__title">{title}</h3>
            </div>
          )}

          {content && (
            <div className={`modal__body modal__body--${modalModifier || ""}`}>
              <ReactMarkdown>{content}</ReactMarkdown>
            </div>
          )}

          <div className="modal__footer">
            <Cta {...cta} />
          </div>
        </div>

        <div className="modal__column">{image && <img src={image} alt="popup" />}</div>
      </div>

      <div className={`modal__overlay modal__overlay--${_visible}`} onClick={modalAction} role="presentation" />
    </div>
  )
}

Modal.defaultProps = {
  restartTimeout: null
}

Modal.propTypes = {
  restartTimeout: PropTypes.func
}

export default Modal
